import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import ReplayPlayer from 'components/UI/Replays/ReplayPlayer';

const ReplayPlayerStyled = withStyles((theme) => {
  return {
  paperWrapper: {
    width: '100%',
    display: 'block',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      content: "' '",
      height: '160px',
      backgroundColor: theme.palette.primary.light,
      //backgroundImage: 'url('+require('assets/images/header_replay.jpg')+')',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      zIndex: -1
    }
  },
  itemVideo: {
    marginBottom: theme.spacing(2)
  },
  itemDescription: {
    marginBottom: theme.spacing(2)
  },
  itemDuration: {
    marginBottom: theme.spacing(2)
  },
  itemCopyright: {
    color: theme.palette.primary.main
  },
  itemGuests: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },

}})(ReplayPlayer)

class ReplayPlayerWrapper extends Component {
  render() {
    return <ReplayPlayerStyled templateProps={{kind: 'fullWidth', maxWidth: 'auto'}} kind={this.props.kind}/>
  }
}

export default ReplayPlayerWrapper;



// WEBPACK FOOTER //
// ./src/components/Replays/ReplayPlayer.jsx